module.exports = __webpack_public_path__ + "img/bg2.f741f064.png";